import {
  jb_audio_player_css_default
} from "./chunk.LI27N7YP.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  setLink
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  ChangesBackgroundColor
} from "./chunk.XYH4LHGJ.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-audio-player/jb-audio-player.ts
var JbAudioPlayer = class extends ChangesBackgroundColor(Spaceable(i)) {
  constructor() {
    super(...arguments);
    this.headline = "";
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      this.intersectionObserver.unobserve(this);
      this.dispatchEvent(
        new CustomEvent("jb-tracking", {
          detail: {
            event: "ce_audio",
            event_version: "v2",
            component_name: "audio-player",
            file_name: this._sourceFilename,
            file_progress: "visible",
            file_type: this._sourceFilename.split(".").pop()?.toLocaleLowerCase()
          },
          bubbles: true,
          composed: true
        })
      );
    });
    this.spriteSvgUrl = "";
    this._progress = 0;
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("duration")) {
      this._updateRemainingTime();
    }
  }
  async firstUpdated() {
    document.addEventListener("keydown", (e2) => {
      if (e2.code === "KeyM") {
        this._audioElement.muted = !this._audioElement.muted;
      }
      if (e2.code === "ArrowUp") {
        this._audioElement.volume = Math.min(1, this._audioElement.volume + 0.1);
      }
      if (e2.code === "ArrowDown") {
        this._audioElement.volume = Math.max(0, this._audioElement.volume - 0.1);
      }
    });
    this._playPauseButton.setMediaElement(this._audioElement);
    this._boundDispatchStartEvent = this._dispatchStartEvent.bind(this);
    this._audioElement.addEventListener("play", this._boundDispatchStartEvent);
    this.intersectionObserver.observe(this);
  }
  _dispatchPercentageEvent() {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_audio",
          event_version: "v2",
          component_name: "audio-player",
          file_name: this._sourceFilename,
          file_progress: this._progress + "%",
          file_type: this._sourceFilename.split(".").pop()?.toLocaleLowerCase()
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _dispatchStartEvent() {
    this._audioElement.removeEventListener("play", this._boundDispatchStartEvent);
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_audio",
          event_version: "v2",
          component_name: "audio-player",
          file_name: this._sourceFilename,
          file_progress: "start",
          file_type: this._sourceFilename.split(".").pop()?.toLocaleLowerCase()
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _downloadClick(event) {
    event.stopPropagation();
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_download",
          event_version: "v2",
          component_name: "listing",
          file_name: this._sourceFilename,
          file_type: this._sourceFilename.split(".").pop()?.toLowerCase(),
          interaction_text: this.downloadText ?? this._sourceFilename
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _getContentSpacingProperties() {
    if (this.noVerticalSpace) {
      return { grid: true, colsMdUp: 8, type: "no-vertical-space" };
    }
    return { grid: true, colsMdUp: 8, type: "media" };
  }
  _handleSeekInput() {
    this._audioElement.currentTime = parseInt(this._seek.value, 10);
  }
  _initializeAudioMetaData() {
    this.duration = Math.round(this._audioElement.duration);
  }
  _setPodcastLink(link, icon, ariaLabel) {
    const anchor = document.createElement("a");
    setLink(anchor, link);
    anchor.innerHTML = icon;
    anchor.setAttribute("aria-label", ariaLabel);
    anchor.setAttribute("title", ariaLabel);
    return anchor;
  }
  get _sourceFilename() {
    return this.src.data.downloadFileName ?? this.src.href.split("/").pop() ?? "";
  }
  _updateRemainingTime() {
    const currentTime = this._audioElement?.currentTime || 0;
    this._seek.value = Math.round(currentTime).toString();
    this._timer.seconds = -((this.duration || 0) - currentTime);
    const currentPercentagePlayed = this.duration > 0 ? Math.round(currentTime / this.duration * 10) * 10 : 0;
    if (currentPercentagePlayed > this._progress) {
      this._progress = currentPercentagePlayed;
      this._dispatchPercentageEvent();
    }
  }
  render() {
    return b`
      <section>
        ${this.headline ? b`<jb-heading>${this.headline}</jb-heading>` : A}
        <div class="description">
          ${this.description ? b`<p>${this.description}</p>` : A}
          ${this.spotifyPodcastLink?.href || this.applePodcastLink?.href ? b`
                  <div class="links">
                    ${this.spotifyPodcastLink?.href ? this._setPodcastLink(
      this.spotifyPodcastLink,
      '<jb-icon iconName="proprietary:spotify_podcast"></jb-icon>',
      this.ariaLabels?.spotifyPodcast
    ) : A}
                    ${this.applePodcastLink?.href ? this._setPodcastLink(
      this.applePodcastLink,
      '<jb-icon iconName="proprietary:apple_podcast"></jb-icon>',
      this.ariaLabels?.applePodcast
    ) : A}
                  </div>
                ` : A}
        </div>

        <div>
          <jb-play-pause-button
            .ariaLabelPause=${this.ariaLabels?.pause}
            .ariaLabelPlay=${this.ariaLabels?.play}
            .spriteSvgUrl=${this.spriteSvgUrl}
          ></jb-play-pause-button>
          <input
            aria-label="${this.ariaLabels?.seek ?? "Seek"}"
            @input=${this._handleSeekInput}
            type="range"
            min="0"
            value="0"
            max="${Math.round(this.duration)}"
          />
          <jb-timer
            .align=${"right"}
            .seconds=${this.duration}
          ></jb-timer>
        </div>
        <audio
          @timeupdate=${this._updateRemainingTime}
          @loadedmetadata=${this._initializeAudioMetaData}
          preload="metadata"
        >
          <source
            src="${this.src.href}"
            type="${this.mimeType}"
          />
        </audio>
        ${this.downloadText ? b`
                <jb-listing-item
                  .file=${{ size: this.fileSize || "", type: this.fileType || "" }}
                  .link=${this.src}
                  .type=${"download"}
                  .text=${this.downloadText}
                  @jb-link:clicked=${this._downloadClick}
                ></jb-listing-item>
              ` : A}
      </section>
    `;
  }
};
JbAudioPlayer.styles = [reset_css_default, jb_audio_player_css_default];
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "applePodcastLink", 2);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "description", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "downloadText", 2);
__decorateClass([
  n({ type: Number })
], JbAudioPlayer.prototype, "duration", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileDate", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileId", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileSize", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileType", 2);
__decorateClass([
  n({ reflect: true })
], JbAudioPlayer.prototype, "headline", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "mimeType", 2);
__decorateClass([
  n({ type: Boolean })
], JbAudioPlayer.prototype, "noVerticalSpace", 2);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "spotifyPodcastLink", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "spriteSvgUrl", 2);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "src", 2);
__decorateClass([
  e("audio")
], JbAudioPlayer.prototype, "_audioElement", 2);
__decorateClass([
  e("jb-play-pause-button")
], JbAudioPlayer.prototype, "_playPauseButton", 2);
__decorateClass([
  e("input")
], JbAudioPlayer.prototype, "_seek", 2);
__decorateClass([
  e("jb-timer")
], JbAudioPlayer.prototype, "_timer", 2);
JbAudioPlayer = __decorateClass([
  customElement("jb-audio-player")
], JbAudioPlayer);

export {
  JbAudioPlayer
};
